var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    viewBox: "0 0 16 18",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 5.92212C13.4926 5.92212 14.5 4.91476 14.5 3.67212C14.5 2.42948 13.4926 1.42212 12.25 1.42212C11.0074 1.42212 10 2.42948 10 3.67212C10 4.91476 11.0074 5.92212 12.25 5.92212Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 11.1721C4.49264 11.1721 5.5 10.1648 5.5 8.92212C5.5 7.67948 4.49264 6.67212 3.25 6.67212C2.00736 6.67212 1 7.67948 1 8.92212C1 10.1648 2.00736 11.1721 3.25 11.1721Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 16.4221C13.4926 16.4221 14.5 15.4148 14.5 14.1721C14.5 12.9295 13.4926 11.9221 12.25 11.9221C11.0074 11.9221 10 12.9295 10 14.1721C10 15.4148 11.0074 16.4221 12.25 16.4221Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1925 10.0546L10.315 13.0396"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3075 4.80463L5.1925 7.78963"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.f7808ff57e0df9a9bccee6a5bfab5eaa.svg";
export { ForwardRef as ReactComponent };